// extracted by mini-css-extract-plugin
module.exports = {"menu":"e_9y","alignRight":"e_-y","alignLeft":"e_az","item":"e_bz","icon":"e_cz","soft":"e_dz"};